/**
    商品列表
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>我的订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6" class="leftaside">
          <el-menu
                router
                class="el-menu-vertical-demo">
                    <el-menu-item-group v-for="item in leftMenu" :key="item.id">
                        <template slot="title">{{item.menu}}</template>
                        <el-menu-item v-for="subMenu in item.sub_menu" :key="subMenu.id" :index="subMenu.url">{{subMenu.title}}</el-menu-item>
                    </el-menu-item-group>                
                </el-menu>
      </el-col>
      <el-col :span="17" class="rightaside">
          <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
        // leftMenu:[
        //     {
        //         id:1,
        //         menu:'订单中心',
        //         sub_menu:[
        //             {
        //                 id:1,
        //                 title:'我的订单',
        //                 url:'/myOrderRight',
        //             },
        //             {
        //                 id:2,
        //                 title:'商品评价',
        //                 url:'/goodsAppraisal',
        //             },
        //             {
        //                 id:3,
        //                 title:'积分订单',
        //                 url:'/pointsOrder',
        //             }
        //         ]
        //     },
        //     {
        //         id:2,
        //         menu:'关注中心',
        //         sub_menu:[
        //             {
        //                 id:1,
        //                 title:'商品收藏',
        //                 url:'/goodsCollection',
        //             },
        //              {
        //                 id:2,
        //                 title:'店铺收藏',
        //                 url:'/shopCollection',
        //             },
        //             {
        //                 id:3,
        //                 title:'我的足迹',
        //                 url:'/myFooter',
        //             }
        //         ]
        //     }, 
        //     {
        //         id:2,
        //         menu:'个人中心',
        //         sub_menu:[
        //             {
        //                 id:1,
        //                 title:'个人信息',
        //                 url:'/myInfomation',
        //             },
        //              {
        //                 id:2,
        //                 title:'账号安全',
        //                 url:'/accountSecurity',
        //             }, 
        //             {
        //                 id:3,
        //                 title:'绑定授权',
        //                 url:'/binding',
        //             },
        //             {
        //                 id:4,
        //                 title:'收货地址',
        //                 url:'/address',
        //             }
        //         ]
        //     },            
        //     {
        //         id:3,
        //         menu:'客户服务',
        //         sub_menu:[
        //             {
        //                 id:1,
        //                 title:'退款退货',
        //                 url:'/refund ',
        //             },
        //             {
        //                 id:1,
        //                 title:'商品咨询',
        //                 url:'/consultation',
        //             }
        //         ]
        //     },
        //     {
        //         id:4,
        //         menu:'财产中心',
        //         sub_menu:[
        //             {
        //                 id:1,
        //                 title:'我的积分',
        //                 url:'/myScores',
        //             },
        //             {
        //                 id:2,
        //                 title:'账户余额',
        //                 url:'/accountBalance',
        //             },
        //             {
        //                 id:3,
        //                 title:'我的红包',
        //                 url:'/myRedPack',
        //             },
        //             {
        //                 id:3,
        //                 title:'我的充值卡',
        //                 url:'/myRechargeCard',
        //             }
        //         ]
        //     }
        // ],
        leftMenu:[
            {
                id:1,
                menu:'订单中心',
                sub_menu:[
                    {
                        id:1,
                        title:'我的订单',
                        url:'/myOrderRight_supplier',
                    },
                    {
                        id:2,
                        title:'商品评价',
                        url:'/goodsAppraisal_supplier',
                    },
                    {
                        id:3,
                        title:'积分订单',
                        url:'/pointsOrder_supplier',
                    }
                ]
            },
            // {
            //     id:2,
            //     menu:'关注中心',
            //     sub_menu:[
            //         {
            //             id:1,
            //             title:'商品收藏',
            //             url:'/goodsCollection',
            //         },
            //          {
            //             id:2,
            //             title:'店铺收藏',
            //             url:'/shopCollection',
            //         },
            //         {
            //             id:3,
            //             title:'我的足迹',
            //             url:'/myFooter',
            //         }
            //     ]
            // }, 
            {
                id:2,
                menu:'个人中心',
                sub_menu:[
                    // {
                    //     id:1,
                    //     title:'个人信息',
                    //     url:'/myInfomation',
                    // },
                    //  {
                    //     id:2,
                    //     title:'账号安全',
                    //     url:'/accountSecurity',
                    // }, 
                    // {
                    //     id:3,
                    //     title:'绑定授权',
                    //     url:'/binding',
                    // },
                    {
                        id:4,
                        title:'收货地址',
                        url:'/address_supplier',
                    }
                ]
            },            
            // {
            //     id:3,
            //     menu:'客户服务',
            //     sub_menu:[
            //         {
            //             id:1,
            //             title:'退款退货',
            //             url:'/refund ',
            //         },
            //         {
            //             id:1,
            //             title:'商品咨询',
            //             url:'/consultation',
            //         }
            //     ]
            // },
            {
                id:4,
                menu:'财产中心',
                sub_menu:[
                    // {
                    //     id:1,
                    //     title:'我的积分',
                    //     url:'/myScores',
                    // },
                    // {
                    //     id:2,
                    //     title:'账户余额',
                    //     url:'/accountBalance',
                    // },
                    {
                        id:3,
                        title:'我的红包',
                        url:'/myRedPack_supplier',
                    },
                    // {
                    //     id:3,
                    //     title:'我的充值卡',
                    //     url:'/myRechargeCard',
                    // }
                ]
            }
        ],
        searchValue:'',        
        // orderInfoList:[
        //     {
        //         id:0,
        //         status:1, // 1等待买家付款 2等待卖家发货 3等待买家确认收获 4交易成功 5交易关闭
        //         time:'2020-12-1 22:22:22',
        //         shopName:'POLA宝丽官方旗舰店',
        //         orderNum:'DD-20201204-0009',
        //         orderTotal:725,
        //         goods:[
        //                 {
        //                    id:0,
        //                    photos:'',
        //                    proTitle: 'SK-II大红瓶面部护肤精华面霜提亮修护补水饱满弹润官方sk2skll',
        //                    price:123,
        //                    number:1,
        //                 },
        //                 {
        //                    id:1,
        //                    photos:'',
        //                    proTitle: 'Dior迪奥 迪奥小姐香水 经典女士香水 迷人馥郁花香',
        //                    price:123,
        //                    number:1,
        //                 },
        //                  {
        //                    id:2,
        //                    photos:'',
        //                    proTitle: 'SK-II大红瓶面部护肤精华面霜提亮修护补水饱满弹润官方sk2skll',
        //                    price:123,
        //                    number:1,
        //                 },
        //                 {
        //                    id:3,
        //                    photos:'',
        //                    proTitle: 'Dior迪奥 迪奥小姐香水 经典女士香水 迷人馥郁花香',
        //                    price:123,
        //                    number:1,
        //                 }
        //             ]

        //     }
        // ],
        waitPayList:[],
        waitSendList:[],
        waitGetList:[],
        finishList:[],
        closeList:[],
        
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
//     //   取消订单
//      cancleOrder() {
//         this.$confirm('确定取消订单?', '提示', {
//           confirmButtonText: '确定',
//           cancelButtonText: '取消',
//           type: 'warning'
//         }).then(() => {
//           this.$message({
//             type: 'success',
//             message: '取消成功!'
//           });
//         }).catch(() => {
//           this.$message({
//             type: 'info',
//             message: '已取消'
//           });          
//         });
//       },

//     //   移出订单
//     removeOrder(){
//         this.$confirm('确定移除订单吗?', '提示', {
//           confirmButtonText: '确定',
//           cancelButtonText: '取消',
//           type: 'warning'
//         }).then(() => {
//           this.$message({
//             type: 'success',
//             message: '移除成功!'
//           });
//         }).catch(() => {
//           this.$message({
//             type: 'info',
//             message: '已移除'
//           });          
//         });
//     },

//    nextEditResource(){
//        this.$refs.sizeForm.validate((valid) => {
//           if (valid) {
//             if(this.sizeForm.checkedBox){
//                 this.errerInfo=false;
//                 this.$router.push(`/merchantForm?type=${this.$route.query.type}`)
//             }else{
//                 this.errerInfo=true;
//             }
//           }
//         });
//    }
  },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.leftaside.el-col.el-col-6 {
    background: white;
    padding: 30px;
    box-sizing: border-box;
    .el-menu{
        border-right:0px;
        li.el-menu-item-group {
            margin-bottom: 15px;
        }
    }
    /deep/ .el-menu-item-group__title {
            padding: 7px 0 10px 20px;
            line-height: normal;
            font-size: 14px;
            color: #333;
        }
    li.el-menu-item {
        height: 24px;
        line-height: 24px;
        font-size: 12px;        
    }
    .el-menu-item:focus, .el-menu-item:hover {
        outline: 0;
        background-color: transparent;
    }
    .el-menu-item.is-active {
        color: #ff6700;
    }
}

.rightaside{
    background: white;
    margin-left: 15px;
    padding: 20px !important;
    .rightaside_content{
        .headerTitle{
            font-size: 20px;
            height: 40px;
            line-height: 40px;
            color: #666;
        }
        /deep/.el-tabs--border-card{
            border: 0px;
            box-shadow: unset;
            .el-tabs__header{
                border-bottom: 0px;
                background: white;
               /deep/ .el-tabs__item.is-active {
                    color:  #ff6700;
                    background-color: transparent;
                    border-right-color: transparent;
                    border-left-color: transparent;
                }
            }
        }
        .search_box {
            text-align: right;
            margin-bottom: 10px;
            .input-with-select.el-input.el-input-group.el-input-group--append {
                width: 40%;
            }
        }
        .orderbox_info {
            // padding: 20px;
            // box-sizing: border-box;
             border: 1px solid#ccc;
            .orderbox_info_header {
                padding: 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #ccc;
                display: flex;
                justify-content: space-between;
                p{
                    font-size: 16px;
                    color: #ff6700;
                    margin-bottom: 5px;
                }
                .order_money i{
                    font-size: 20px;
                    color: #ff6700;
                }
            }
            .order_goods_whole {
                padding: 20px;
                box-sizing: border-box;
                .order_goods {
                    margin-bottom: 20px;
                    .order_Info_item {
                        margin-left: 12px;
                    }
                }
                button.el-button.buttonStyle {
                    padding: 6px 30px;
                    font-size: 12px;
                    margin-bottom: 6px;
                    margin-left: 0;
                }
                .dangerBg.buttonStyle{
                    background-color:  #ff6700;
                    border-color:  #ff6700;
                }
                .el-button--danger.is-plain{
                    background: white;
                }
                .el-button--danger:focus, .el-button--danger:hover{
                    color: white;
                    background: #F56C6C;
                }
            }
        }
        .tab_pane_content{
            .noData{
                text-align: center;
                height: 200px;
                line-height: 200px;
            }
        }

    }
}

</style>

 
 

 


// WEBPACK FOOTER //
// src/views_supplier/myOrder/index.vue